var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:assets' to update
import Asset from '../asset-internal';
function DatabricksLogomark(_a) {
    var restProps = __rest(_a, []);
    return (_jsx(Asset, Object.assign({ viewBox: "0 0 30 32" }, restProps, { children: _jsx("path", { d: "M28.132 13.177 14.94 20.655.922 12.689l-.655.353v5.781l14.689 8.37 13.193-7.479v3.076l-13.193 7.479L.922 22.303l-.655.352v.975L14.956 32l14.74-8.37v-5.78l-.656-.353-14.1 7.966-13.144-7.479v-3.025l13.143 7.429 14.74-8.37V8.319l-.757-.403-13.983 7.916L2.502 8.756 14.94 1.731l10.269 5.782.924-.488V6.32L14.94 0 .25 8.336v.89l14.69 8.37 13.192-7.478v3.059Z", fill: "currentColor" }) })));
}
export default DatabricksLogomark;
